
import React, { useEffect, useState } from "react";

import { FaRegEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import { BsTrashFill } from "react-icons/bs";
import DataTable from 'react-data-table-component'
import { IoSearch } from "react-icons/io5";
import { useCreateUnitsMutation, useDeleteUnitsMutation, useGetUnitsQuery, useUpdateUnitsMutation } from "../../store/api/UnitsApi";





const initialUnits = {
  Id: 0,
  name: '',
}


export default function Units() {
  
  const [isUpdate, setIsUpdate] = useState(false);
  const [Units, setUnits] = useState(initialUnits)
  const [CreateUnits] = useCreateUnitsMutation()
  const [updateUnits] = useUpdateUnitsMutation()
  const [deleteCustomer] = useDeleteUnitsMutation()

  const [UnitsList, setUnitsList] = useState([]);
  const { data } = useGetUnitsQuery();

  // Update Units state when data changes

  useEffect(() => {
    if (data) {
      setUnitsList(data);
    }
  }, [data]);




  // create new Units method
  const handlecreateUnits = async (event) => {
    event.preventDefault()

    const Data = {
      name: Units.name,
    }

    await CreateUnits(Data).then((done) => {
        console.log('done', done.data.status)
        if (done.data.status === 200) {
          Swal.fire({
            title: 'Success!',
            text: done.data.message,
            icon: 'success',
            confirmButtonText: 'Done'
          })
        } else {
          Swal.fire({
            title: 'Error!',
            text: done.data.message,
            icon: 'error',
            confirmButtonText: 'close'
          })
        }
      })

      resetFormData()
  }


  // update exist Units
  const handleUpdatesUnits = async (e) => {
    e.preventDefault()

    const UnitsData = {
      Id: Units.Id,
      name: Units.name,
    }


    await updateUnits(UnitsData).then((done) => {
      if (done?.data.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: done.data.message,
          icon: 'success',
          confirmButtonText: 'Done'
        })
      } else {
        Swal.fire({
          title: 'Error!',
          text: done.data.message,
          icon: 'error',
          confirmButtonText: 'Close'
        })
      }
    });

    ResetFormChanges();
  }



  // Delete Units

  const handleDelete = async (value) => {
    const { id } = value
    Swal.fire({
      title: 'Are you sure?',
      text: 'you want to delete this Unit !!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCustomer(id).then((done) => {
          if (done?.data.status === 200) {
            Swal.fire({
              title: 'Success!',
              text: done.data.message,
              icon: 'success',
              confirmButtonText: 'Done'
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: done.data.message,
              icon: 'error',
              confirmButtonText: 'Close'
            })
          }
        })
      }
    })
  }


  const resetFormData = () => {
    setUnits({
      ...initialUnits,
    });
    
  };


  // reading suppliers list







  // prepare data supplier to be updated
  const handleUpdate = (updateData) => {
      
      if (!isUpdate) {
        setIsUpdate(!isUpdate);
      }
   
      setUnits({
        Id: updateData.id,
        name: updateData.name,
      })
    
  }



   // search Units
   const searchUnits = (searchText) => {
    if (!searchText) {
      return UnitsList
    }

    const filteredUnitsList = UnitsList.filter((Units) => {
      const nameMatch = Units.name.toLowerCase().includes(searchText.toLowerCase())
      return nameMatch 
    })

    return filteredUnitsList
  }


  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(3)
  const [formData, setFormData] = useState([])

  // changes pages
  const handlePageChange = (page) => {
    setPage(page)
  }

  // change perpage
  const handlePerPageChange = (perPage) => {
    setPerPage(perPage)
  }

  const ResetFormChanges = () => {
    setIsUpdate(!isUpdate);
    setUnits(initialUnits);
  }

  // search hanlder
  const handleSearch = (e) => {
    setFormData(searchUnits(e.target.value))
  }







  // Units Table columns
  const _columns = [
    { name: 'Id', selector: (row) => row.id, sortable: true, center: true },
   
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      center: false
    },
    {
      name: 'Create At',
      selector: (row) => row.created,
      sortable: true,
      center: true
    },
    {
      name: 'Updated At',
      selector: (row) => row.updated,
      sortable: true,
      center: true
    },

    {
      name: 'Actions',
      cell: (row) => (
        <>
          <button
            style={{ background: '#1a2131' }}
            className="btn btn-success me-3 border-0  text-white"
            onClick={() => handleUpdate(row)}
          >
            <FaRegEdit />
          </button>
          <button
            style={{ background: '#A0374F' }}
            className="btn btn-danger me-3 text-white border-0"
            onClick={() => handleDelete(row)}
          >
            <BsTrashFill />
          </button>
        </>
      ),
      center: true
    }
  ]


  const paginatedData = formData.length
  ? formData.slice((page - 1) * perPage, page * perPage)
  : UnitsList.slice((page - 1) * perPage, page * perPage)



  const canSave = [Units.name].every(Boolean)
  const canUpdate = [Units.name].every(Boolean)






  return (
    <div>
      <div className="block-content-full">
        <div class="block-content">

          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-4 col-12">
              <form>
                <div className="row">
                <div className="col-sm-12 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                          Units Name
                          </label>
                        </div>
                        <input
                        style={{ height: '45px' }}
                        autoComplete='off'
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Units Name"
                          value={Units.name}
                          onChange={(e) => setUnits({ ...Units, name: e.target.value })}
                        />
                      </div>
                    </div>
                </div>

                <div class="mt-3 pb-3">
                  <button
                    type="button"
                    class={isUpdate ? "btn btn-success p-2" : "btn btn-primary p-2"}
                    data-dismiss="modal"
                    onClick={isUpdate ? handleUpdatesUnits : handlecreateUnits}
                    disabled={isUpdate ? !canUpdate : !canSave}
                  >
                    {isUpdate ? "Update Changes" : "Save changes"}
                  </button>
                  {
                    isUpdate ?  <button
                      type="button"
                      class={"btn btn-secondary p-2 mx-3"}
                      data-dismiss="modal"
                      onClick={ResetFormChanges}
                    >
                      Reset
                    </button>: (<></>)
                  }
                </div>
              </form>
            </div>


            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-8 col-12 bg-light vh-100">
              <div className="block-content block-content-full">
                <h2 className="content-heading">Units List</h2>
                <div className="d-flex mb-3">
              <div className="input-group">
                <input
                  className="form-control"
                  placeholder="Search..."
                  type="text"
                  style={{ height: '40px' }}
                  //value={searchText}
                  onChange={handleSearch}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <IoSearch />
                  </span>
                </div>
              </div>
          
            </div>
              </div>
              <DataTable
                pointerOnHover
                className="rounded-3"
                columns={_columns}
                data={paginatedData}
                striped
                highlightOnHover
                pagination
                paginationServer
                paginationTotalRows={UnitsList.length}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[1, 3, 5, 50]}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerPageChange}
              />
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}
